<template>
    <div>
        <!-- 修改 loading 组件的样式 -->
        <van-overlay :show="loading" class="custom-overlay">
            <div class="loading-wrapper">
                <van-loading type="spinner" vertical size="36" >加载中...</van-loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        }
    },
}
</script>

<style lang="scss" scoped>
.custom-overlay {
    z-index: 99999 !important; // 设置较高的 z-index 确保在最上层
}

.loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>